<template>
  <div class="main">
    <div class="back" @click="back">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('experimentCheck.common.back') }}</span>
    </div>
    <div class="headline">{{ $t('experimentCheck.correct.title') }}</div>
    <div class="content" v-if="studentReportList.length !== 0">
      <!-- 文本编辑 -->
      <div>
        <onlyoffice-editor
          ref="onlyofficeEditor"
          :src="onlyofficeURL + '/web-apps/apps/api/documents/api.js'"
          :config="editorConfig"
        />
      </div>
      <!-- 批改报告 -->
      <div>
        <div class="desc">
          <span>{{ $t('experimentCheck.correct.grading') }}</span>
          <span>{{ studentReportList.filter(item => item.isCheck === '1').length }}</span>
          <span>/</span>
          <span>{{ studentReportList.length }}</span>
        </div>
        <div class="member">
          <div>
            <div class="list" :class="{ correcting: selectedReport.reportId === item.reportId, correctOver: item.isCheck === '1' }" v-for="item in studentReportList" :key="item.id" @click="changeReport(item)">
              <img :src="item.avatar || defaultAvatar" alt="" />
              <span>{{ item.studentName }}</span>
              <span v-if="selectedReport.reportId === item.reportId">{{ $t('experimentCheck.correct.gradingIn') }}</span>
            </div>
          </div>
        </div>
        <div class="grade">
          <span>{{ $t('experimentCheck.correct.enterScore') }}</span>
        </div>
        <a-input v-model="score" :placeholder="$t('experimentCheck.correct.scorePlaceholder')" @change="handleScoreChange" @blur="handleScoreBlur" />
        <a-button @click="submit" :class="{ again: selectedCheckStatus === '1' }">{{ checkStatus[selectedCheckStatus] }}</a-button>
      </div>
      <a-spin :tip="$t('experimentCheck.correct.savingTip')" class="spin" v-if="spin"></a-spin>
    </div>
    <div class="empty" v-else>
      <div>
        <img src="@/assets/img/pic_kh.png" alt="">
        <div>{{ $t('experimentCheck.correct.noReport') }}</div>
      </div>
    </div>
    <Upload ref="upload" @uploadData="handleDownloadSuccess" :pathname="pathname" :isCommon="false" :useCDN="false" hidden></Upload>
  </div>
</template>
<script>
import { OnlyofficeEditor } from 'onlyoffice-vue'
import Upload from '@/components/upload/index.vue'
import { studentReportList, correctReport } from '@/api/experiment'
import cookie from 'js-cookie'
import SparkMD5 from 'spark-md5'
import defaultAvatar from '@/assets/icons/icon_m@2x.png'
export default {
  components: {
    OnlyofficeEditor,
    Upload
  },
  data() {
    return {
      score: '',
      onlyofficeURL: 'https://office.growlib.cn',
      editorConfig: {
        documentType: 'pdf',
        document: {
          fileType: 'pdf',
          key: '91e907ca41eaac941edf7e0e5d17e035',
          url: 'https://src-glp-u-resource.growlib.com/school-level-platform/2025331/16c9e27696bfa37db0bb3b93d0217ce2.pdf',
          title: this.$t('experimentCheck.correct.filePreview')
        }
      },
      spin: false,
      studentReportList: [],
      selectedReport: {
        score: ''
      },
      checkStatus: {
        0: this.$t('experimentCheck.correct.finishGrading'),
        1: this.$t('experimentCheck.correct.regrading'),
        2: this.$t('experimentCheck.correct.finishAndNext')
      },
      defaultAvatar
    }
  },
  computed: {
    selectedCheckStatus() {
      return this.selectedReport.isCheck === '1' ? '1' : this.studentReportList.filter(item => item.isCheck === '2').length > 1 ? '2' : '0'
    }
  },
  methods: {
    async getStudentReportList() {
      console.log('this.currentRecord ----->', this.currentRecord)
      const res = await studentReportList({
        experimentId: this.currentRecord
      })
      this.studentReportList = res.data.list
      if (this.studentReportList.length > 0) {
        this.changeReport(this.studentReportList[0])
      }
    },
    // 切换批改的报告
    async changeReport(item) {
      this.score = item.score
      if (item.isCheck !== '1') this.score = ''
      this.selectedReport = item
      this.pathname = new URL(item.reportUrl).pathname
      this.previewDocx()
    },
    async previewDocx() {
      this.url = this.selectedReport.reportUrl
      const format = this.url.split('.')[this.url.split('.').length - 1]
      console.log(this.url)
      const md5 = await this.getWordFileMD5(this.url)
      console.log('md5 ----->', md5)
      const typeMap = {
        word: ['doc', 'docx'],
        cell: ['xlsx', 'xls'],
        slide: ['ppt', 'pptx'],
        pdf: ['pdf']
      }
      let documentType
      for (const key in typeMap) {
        if (typeMap[key].includes(format)) {
          documentType = key
          break
        }
      }
      this.editorConfig = {
        // 编辑器宽度
        width: '100%',
        // 编辑器高度
        height: 800,
        // 编辑器类型，支持 word（文档）、cell（表格）、slide（PPT）
        documentType,
        // 文档配置
        document: {
          // 文件类型
          fileType: format,
          // 文档标识符
          key: md5,
          // 文档地址，绝对路径
          url: this.url,
          // 文档标题
          title: '文件预览',
          permissions: {
            edit: true, // （文件是否可以编辑，false时文件不可编辑）
            fillForms: false, // 定义是否能在文档中填充表单
            print: true, // 定义文档是否能打印
            review: false, // 第一是否显示审阅文档菜单
            comment: true // 定义是否可以注释文档。如果注释权限设置为“ true”，则文档侧栏将包含“注释”菜单选项；只有将mode参数设置为edit时才生效，默认值与edit参数的值一致。
          }
        },
        editorConfig: {
          mode: 'edit', // 模式：edit 表示编辑模式, view 表示只读模式
          change: false,
          user: {
            // "group": "Group1,Group2",
            id: '78e1e841',
            name: cookie.getJSON('user_infor', {
              domain: '.' + location.hostname
            }).name
          },
          customization: {
            commentAuthorOnly: true,
            comments: true // 启用批注功能
          },
          callbackUrl:  window.location.origin + '/api/save-file'
        },
        events: {
          onrequestsaveas: (data, callback) => {
            console.log('onrequestsaveas', data)
          },
          onDocumentStateChange: (data, callback) => {
            console.log('onDocumentStateChange', data)
          },
          onDownloadAs: (data, callback) => {
            console.log('onDownloadAs', data)
            const proxyUrl = new URL(data.data.url).pathname.replace('cache', 'office') + new URL(data.data.url).search
            // window.open(data.data.url)
            // 将文件url转化成base64
            fetch(proxyUrl)
              .then(res => res.blob())
              .then(blob => {
                const reader = new FileReader()
                reader.readAsDataURL(blob)
                reader.onload = e => {
                  console.log(e)
                  const base64 = e.target.result.split(',')[1]

                  // 将base64转化成file
                  const bstr = atob(base64) // 解码 Base64
                  let n = bstr.length
                  const u8arr = new Uint8Array(n)
                  while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                  }
                  const file = new File([u8arr], 'test.' + format, { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
                  console.log(file)
                  this.$refs.upload.handleChange({
                    target: {
                      files: [file]
                    }
                  })
                }
              })
          }
        }
      }
      console.log(this.editorConfig)
    },
    async getWordFileMD5(url) {
      const response = await fetch(url);
      const reader = response.body.getReader()
      const spark = new SparkMD5.ArrayBuffer()
      let receivedLength = 0

      while (true) {
        const { done, value } = await reader.read()
        if (done) break
        spark.append(value) // 追加数据
        receivedLength += value.byteLength
      }

      return spark.end() // 计算最终 MD5
    },
    // 下载
    async download() {
      console.log(this.$refs.onlyofficeEditor)
      const documentEditor = this.$refs.onlyofficeEditor.editor
      await documentEditor.downloadAs()
      // documentEditor.getDocumentAsBase64((base64) => {
      //     const fileName = "my_document.docx"; // 自定义文件名
      //     const link = document.createElement("a");
      //     link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + base64;
      //     link.download = fileName;
      //     document.body.appendChild(link);
      //     link.click();
      //     document.body.removeChild(link);
      // }, (error) => {
      //     console.error("下载失败", error);
      // });
    },
    async submit() {
      if (this.score === '') {
        this.$message.error(this.$t('experimentCheck.correct.pleaseEnterScore'))
        return
      }
      this.spin = true
      this.download()
    },
    // 文件更新成功
    async handleDownloadSuccess(data) {
      console.log(data)
      const res = await correctReport({
        reportId: this.selectedReport.reportId,
        score: this.score
      })
      console.log(res)
      if (res.code === 200) {
        this.studentReportList.forEach(item => {
          if (item.reportId === this.selectedReport.reportId) {
            item.score = this.score
            item.isCheck = '1'
          }
        })
        const index = this.studentReportList.findIndex(item => item.isCheck === '2')
        if (index !== -1) {
          this.changeReport(this.studentReportList[index])
        }
      } else {
        this.$message.error(this.$t('experimentCheck.correct.gradingFailed'))
      }
      this.spin = false
    },
    handleScoreChange(e) {
      // 只允许输入数字
      let value = e.target.value.replace(/[^\d]/g, '')
      // 去除首位的0
      value = value.replace(/^0+(\d)/, '$1')
      // 限制最大长度为3位
      if (value.length > 3) {
        value = value.slice(0, 3)
      }
      console.log(value)
      this.$nextTick(() => {
        e.target.value = value
      })
    },
    handleScoreBlur() {
      // 失去焦点时确保值在0-100范围内
      if (this.score !== '') {
        const num = parseInt(this.score)
        console.log(num, num > 100)
        if (num > 100) {
          this.score = '100'
        }
      }
    },
    back() {
      this.$router.back()
    },
  },
  mounted() {
    this.currentRecord = this.$route.query.id
    this.getStudentReportList()
  }
}
</script>
<style lang="less" scoped>
.main {
  padding-top: 1px;
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    margin-bottom: 25px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    margin: 26px 5px 15px 15px;

    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .headline {
    font-weight: 600;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    margin: 25px 0 0 15px;
    border-bottom: 1px solid #EDEDED;
    padding-bottom: 10px;
  }
  .content {
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    height: calc(100vh - 188px);
    background-color: #e4e4e4;
    position: relative;
    > div:nth-child(1) {
      padding: 10px 40px 10px 20px;
      flex: 1;
      height: 100%;
      /deep/ iframe {
        width: 100%;
        height: 100%;
      }
    }
    > div:nth-child(2) {
      width: 230px;
      height: 100%;
      background: linear-gradient(195deg, #f5f5f6 0%, #ffffff 100%);
      margin-left: auto;
      padding: 0 12px;
      .desc {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        margin-top: 19px;
        position: relative;
        padding-left: 9px;
        &::before {
          content: '';
          width: 2px;
          height: 10px;
          background-color: #000000;
          position: absolute;
          top: 50%;
          left: 0;
          margin-top: -5px;
        }
        span:nth-child(3) {
          padding: 0 6px;
          color: #687483;
        }
        span:nth-child(4) {
          font-weight: 500;
          color: #687483;
        }
        span:nth-child(2) {
          color: #3f9052;
        }
      }
      .member {
        margin-top: 19px;
        height: 350px;
        overflow-y: auto;
        border-bottom: 1px solid #F1F1F1;
        > div{
          padding-right: 10px;
        }
        .list {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          width: 100%;
          height: 56px;
          background: #ffffff;
          border-radius: 12px;
          border: 1px solid #f1f1f1;
          padding: 0 12px;
          cursor: pointer;
          color: #000000;
          img {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            margin-right: 20px;
          }
          span:nth-child(2) {
            font-size: 14px;
            font-weight: 400;
            // color: #000000;
          }
          span:nth-child(3) {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            margin-left: auto;
          }
        }
        .correcting {
          border: 1px solid #fe7d31;
          color: #fe7d31;
          span:nth-child(3) {
            color: #fe7d31;
          }
        }
        .correctOver {
          border: 1px solid #72e6b3;
          background: #effef4;
          color: #000000;
        }
      }
      .grade {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        margin-top: 19px;
        position: relative;
        padding-left: 9px;
        &::before {
          content: '';
          width: 2px;
          height: 10px;
          background-color: #000000;
          position: absolute;
          top: 50%;
          left: 0;
          margin-top: -5px;
        }
      }
      /deep/ input {
        width: 206px;
        height: 56px;
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #f1f1f1;
        margin-top: 19px;
        font-weight: 500;
        font-size: 18px;
        color: #000000;
      }
      button {
        width: 206px;
        height: 40px;
        background: linear-gradient(231deg, #f58223 0%, #ff6d00 100%);
        box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
        border-radius: 6px;
        margin-top: 98px;
        color: #ffffff;
      }
      .again {
        background: linear-gradient(231deg, #13BDA8 0%, #67CEB0 100%);
      }
    }
    /deep/.spin {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      z-index: 1000;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.7);
      > div{
        margin-left: 6px;
      }
    }
  }
  .empty{
    width: 100%;
    height: calc(100vh - 188px);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    img{
      width: 300px;
    }
    div{
      margin-top: -60px;
    }
  }
}
</style>
